function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.833 12.167A.637.637 0 017.417 12l-4.25-4.333a.403.403 0 010-.584L3.75 6.5c.083-.167.417-.167.583.083l2.834 2.834v-8.5c0-.25.166-.417.416-.417h.834c.25 0 .416.167.416.417v8.5l2.834-2.834a.403.403 0 01.583 0l.583.584a.403.403 0 010 .583L8.583 12a.637.637 0 01-.416.167h-.334zm7.667-1.25v2.916c0 .917-.75 1.667-1.667 1.667H2.167C1.25 15.5.5 14.75.5 13.833v-2.916c0-.25.167-.417.417-.417h.833c.25 0 .417.167.417.417v2.916h11.666v-2.916c0-.25.167-.417.417-.417h.833c.25 0 .417.167.417.417z"
});

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgDownload;